module.exports = __webpack_public_path__ + "img/39.967065d5.png";